"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processYarnWorkspaces = exports.processPnpmWorkspaces = exports.processNpmWorkspaces = exports.inspect = void 0;
const inspect_1 = require("./inspect");
Object.defineProperty(exports, "inspect", { enumerable: true, get: function () { return inspect_1.inspect; } });
const workspaces_1 = require("./workspaces");
Object.defineProperty(exports, "processNpmWorkspaces", { enumerable: true, get: function () { return workspaces_1.processNpmWorkspaces; } });
Object.defineProperty(exports, "processPnpmWorkspaces", { enumerable: true, get: function () { return workspaces_1.processPnpmWorkspaces; } });
Object.defineProperty(exports, "processYarnWorkspaces", { enumerable: true, get: function () { return workspaces_1.processYarnWorkspaces; } });
//# sourceMappingURL=index.js.map